import {
    getRainPreSaleV3Contract,
    getRainInstitutionPreSaleContract,
    getMatchainContract,
    getAstroNovaPreSaleV2Contract,
    getNFAPreSaleContract,
    getLEIAPreSaleContract,
    getLEIAInstitutionPreSaleContract,
    getOlympusPreSaleContract,
    getOlympusInstitutionPreSaleContract,
    getPreSaleContract,
    getinstitutionpresalecontract,
    getLuckifyContract,
    getScrexContract,
    getKAIPreSaleContract,
    getGEMSPreSaleContract,
    // Claim contract imports
    getClaimsContract,
    getLEIAClaimsContract,
    getOlympusClaimsContract,
    getNFAClaimsContract,
    getAstroNovaClaimsContract,
    getAstroNovaClaimsV2Contract,
    getMinersClaimsContract,
    getRainClaimsContract,
    getRainClaimsV2Contract,
    getRainClaimsV3Contract,
    getMatchainClaimsContract,
    getLuckifyClaimsContract,
    getScrexClaimsContract,
    getKAIClaimsContract,
    getAutomationContract
} from "./contractHelpers";
import Environment from "./Environment";

// ============================================================================
// SPECIAL CONTRACT HANDLERS
// ============================================================================
// These projects require custom contract initialization logic
// For standard projects, the default handler is used

const SPECIAL_CONTRACT_HANDLERS = {
    /**
     * RAIN - Multiple versions with institution support
     */
    RAIN: (config, web3) => ({
        contract: getRainPreSaleV3Contract(config.preSaleV3, web3),
        contractInstitution: getRainInstitutionPreSaleContract(config.institutionPreSale, web3),
        claimContract: getRainClaimsContract(config.claim, web3),
        claimContractV2: getRainClaimsV2Contract(config.claimV2, web3),
        claimContractV3: getRainClaimsV3Contract(config.claimV3, web3),
    }),

    /**
     * ASTRANOVA - Multiple versions
     */
    ASTRANOVA: (config, web3) => ({
        contract: getAstroNovaPreSaleV2Contract(config.preSaleV2, web3),
        contractInstitution: null,
        claimContract: getAstroNovaClaimsContract(config.claim, web3),
        claimContractV2: getAstroNovaClaimsV2Contract(config.claimV2, web3),
        claimContractV3: null,
    }),

    /**
     * LEIA - Custom contract with institution support
     */
    LEIA: (config, web3) => ({
        contract: getLEIAPreSaleContract(config.preSale, web3),
        contractInstitution: getLEIAInstitutionPreSaleContract(config.institutionPreSale, web3),
        claimContract: getLEIAClaimsContract(config.claim, web3),
        claimContractV2: null,
        claimContractV3: null,
    }),

    /**
     * OLYMPUS - Custom contract with institution support
     */
    OLYMPUS: (config, web3) => ({
        contract: getOlympusPreSaleContract(config.preSale, web3),
        contractInstitution: getOlympusInstitutionPreSaleContract(config.institutionPreSale, web3),
        claimContract: getOlympusClaimsContract(config.claim, web3),
        claimContractV2: null,
        claimContractV3: null,
    }),

    /**
     * INCENTIV - Custom contract with institution support
     */
    INCENTIV: (config, web3) => ({
        contract: getPreSaleContract(config.preSale, web3),
        contractInstitution: getinstitutionpresalecontract(config.institutionPreSale, web3),
        claimContract: getClaimsContract(config.claim, web3),
        claimContractV2: null,
        claimContractV3: null,
    }),

    /**
     * MATCHAIN - Uses custom contract helper
     */
    MATCHAIN: (config, web3) => ({
        contract: getMatchainContract(config.preSale, web3),
        contractInstitution: null,
        claimContract: getMatchainClaimsContract(config.claim, web3),
        claimContractV2: null,
        claimContractV3: null,
    }),

    /**
     * LUCKIFY - Uses custom contract helper
     */
    LUCKIFY: (config, web3) => ({
        contract: getLuckifyContract(config.preSale, web3),
        contractInstitution: null,
        claimContract: getLuckifyClaimsContract(config.claim, web3),
        claimContractV2: null,
        claimContractV3: null,
    }),

    /**
     * GEMS - Uses custom contract helper
     */
    GEMS: (config, web3) => ({
        contract: getGEMSPreSaleContract(config.preSale, web3),
        contractInstitution: null,
        claimContract: null,
        claimContractV2: null,
        claimContractV3: null,
    }),

    /**
     * NODEMINER - Only has claim contract
     */
    NODEMINER: (config, web3) => ({
        contract: null,
        contractInstitution: null,
        claimContract: getMinersClaimsContract(config.claim, web3),
        claimContractV2: null,
        claimContractV3: null,
    }),

    /**
     * NFA - Uses custom contract helper
     */
    NFA: (config, web3) => ({
        contract: getNFAPreSaleContract(config.preSale, web3),
        contractInstitution: null,
        claimContract: getNFAClaimsContract(config.claim, web3),
        claimContractV2: null,
        claimContractV3: null,
    }),

    /**
     * KAI - Dedicated presale / claims ABIs (createNewRound includes round-type flags)
     */
    KAI: (config, web3) => ({
        contract: getKAIPreSaleContract(config.preSale, web3),
        contractInstitution: null,
        claimContract: getKAIClaimsContract(config.claim, web3),
        claimContractV2: null,
        claimContractV3: null,
    }),
      BYZANLINK: (config, web3) => ({
        contract: getLuckifyContract(config.preSale, web3),
        contractInstitution: null,
        claimContract: getKAIClaimsContract(config.claim, web3),
        claimContractV2: null,
        claimContractV3: null,
    }),
};

// ============================================================================
// DEFAULT CONTRACT HANDLER
// ============================================================================
// Used for projects that follow the standard contract pattern
// (TIGA, CHAINERS, SCREX, etc.) 

const getDefaultContracts = (config, web3) => {
    console.log(config, 'configjsldfjconfig');
    
    return {
        contract: config.preSale ? (config.automation ? getAutomationContract(config.preSale, web3) :   getScrexContract(config.preSale, web3)) : null,
        contractInstitution: config.institutionPreSale ? getScrexContract(config.institutionPreSale, web3) : null,
        claimContract: config.claim ? getScrexClaimsContract(config.claim, web3) : null,
        claimContractV2: config.claimV2 ? getScrexClaimsContract(config.claimV2, web3) : null,
        claimContractV3: config.claimV3 ? getScrexClaimsContract(config.claimV3, web3) : null,
    };
};
// ============================================================================
// MAIN FUNCTION
// ============================================================================
/**
 * Get contract instances for a specific project
 * @param {string} project - Project key (e.g., 'TIGA', 'RAIN', 'MATCHAIN')
 * @param {object} web3 - Web3 instance
 * @returns {object} Object containing contract instances
 */
export function getContracts(project, web3) {
    // Get project configuration from Environment
    const projectConfig = Environment.PROJECTS[project];

    // Handle unknown projects
    if (!projectConfig) {
        console.warn(`[getContracts] Unknown project: ${project}`);
        return {
            contract: null,
            contractInstitution: null,
            claimContract: null,
            claimContractV2: null,
            claimContractV3: null,
        };
    }

    // Check if project has a special contract handler
    if (SPECIAL_CONTRACT_HANDLERS[project]) {
        const contracts = SPECIAL_CONTRACT_HANDLERS[project](projectConfig, web3);
        console.log(`[getContracts] Using special handler for ${project}`);
        return contracts;
    }

    // Use default contract handler for standard projects
    console.log(`[getContracts] Using default handler for ${project}`);
    return getDefaultContracts(projectConfig, web3);
}

// v1
// import {
//     getRainPreSaleV3Contract,
//     getRainInstitutionPreSaleContract,
//     getMatchainContract,
//     getAstroNovaPreSaleV2Contract,
//     getNFAPreSaleContract,
//     getLEIAPreSaleContract,
//     getLEIAInstitutionPreSaleContract,
//     getOlympusPreSaleContract,
//     getOlympusInstitutionPreSaleContract,
//     getPreSaleContract,
//     getinstitutionpresalecontract,
//     getLuckifyContract,
//     getScrexContract,
//     getGEMSPreSaleContract,
//     // Claim contract imports
//     getClaimsContract,
//     getLEIAClaimsContract,
//     getOlympusClaimsContract,
//     getNFAClaimsContract,
//     getAstroNovaClaimsContract,
//     getAstroNovaClaimsV2Contract,
//     getMinersClaimsContract,
//     getRainClaimsContract,
//     getRainClaimsV2Contract,
//     getRainClaimsV3Contract,
//     getMatchainClaimsContract,
//     getLuckifyClaimsContract,
//     getScrexClaimsContract
// } from "./contractHelpers";
// import Environment from "./Environment";

// export function getContracts(project, web3) {
//     let contract = null;
//     let contractInstitution = null;
//     let claimContract = null;
//     let claimContractV2 = null;
//     let claimContractV3 = null;
//     //as all abis have same method names so we can use any one abis from any sales contract instance (that why i'm using Screx ones) 🍻
//     let preSale_Contract = getScrexContract;
//     let claims_Contract = getScrexClaimsContract;
//     switch (project) {
//         case "TIGA":
//             contract = preSale_Contract(Environment.TIGAPreSale, web3);
//             claimContract = claims_Contract(Environment.TIGAClaim, web3);
//             break;
//         case "CHAINERS":
//             contract = preSale_Contract(Environment.CHAINERSPreSale, web3);
//             claimContract = claims_Contract(Environment.CHAINERSClaim, web3);
//             break;
//         case "RAIN":
//             contract = getRainPreSaleV3Contract(Environment.RainPreSaleV3, web3);
//             contractInstitution = getRainInstitutionPreSaleContract(Environment.RainInstitutionPreSale, web3);
//             claimContract = getRainClaimsContract(Environment.RainClaim, web3);
//             claimContractV2 = getRainClaimsV2Contract(Environment.RainClaimV2, web3);
//             claimContractV3 = getRainClaimsV3Contract(Environment.RainClaimV3, web3);
//             break;

//         case "MATCHAIN":
//             contract = getMatchainContract(Environment.MATCHAINPreSale, web3);
//             claimContract = getMatchainClaimsContract(Environment.MATCHAINClaim, web3);
//             break;

//         case "LUCKIFY":
//             contract = getLuckifyContract(Environment.LUCKIFYPreSale, web3);
//             claimContract = getLuckifyClaimsContract(Environment.LUCKIFYClaim, web3);
//             break;

//         case "SCREX":
//             contract = getScrexContract(Environment.SCREXPreSale, web3);
//             claimContract = getScrexClaimsContract(Environment.SCREXClaim, web3);
//             break;
        

//         case "ASTRANOVA":
//             contract = getAstroNovaPreSaleV2Contract(Environment.AstroNovaPreSaleV2, web3);
//             claimContract = getAstroNovaClaimsContract(Environment.AstroNovaClaim, web3);
//             claimContractV2 = getAstroNovaClaimsV2Contract(Environment.AstroNovaClaimV2, web3);
//             break;

//         case "NFA":
//             contract = getNFAPreSaleContract(Environment.NFAPreSale, web3);
//             claimContract = getNFAClaimsContract(Environment.NFAClaim, web3);
//             break;

//         case "LEIA":
//             contract = getLEIAPreSaleContract(Environment.LEIAPreSale, web3);
//             contractInstitution = getLEIAInstitutionPreSaleContract(Environment.LEIAInstitutionPreSale, web3);
//             claimContract = getLEIAClaimsContract(Environment.LEIAClaim, web3);
//             break;

//         case "OLYMPUS":
//             contract = getOlympusPreSaleContract(Environment.OlympusPreSale, web3);
//             contractInstitution = getOlympusInstitutionPreSaleContract(Environment.OlympusInstitutionPreSale, web3);
//             claimContract = getOlympusClaimsContract(Environment.OlympusClaim, web3);
//             break;

//         case "INCENTIV":
//             contract = getPreSaleContract(Environment.PreSale, web3);
//             contractInstitution = getinstitutionpresalecontract(Environment.InstitutionPreSale, web3);
//             claimContract = getClaimsContract(Environment.Claim, web3);
//             break;

//         case "GEMS":
//             contract = getGEMSPreSaleContract(Environment.GemsPreSale, web3);
//             break;

//         case "NODEMINER":
//             claimContract = getMinersClaimsContract(Environment.MinersClaim, web3);
//             break;

//         default:
//             console.warn("Unknown project:", project);
//     }

//     return {
//         contract,
//         contractInstitution,
//         claimContract,
//         claimContractV2,
//         claimContractV3
//     };
// }
// v2
// import {
//     getRainPreSaleV3Contract,
//     getRainInstitutionPreSaleContract,
//     getMatchainContract,
//     getAstroNovaPreSaleV2Contract,
//     getNFAPreSaleContract,
//     getLEIAPreSaleContract,
//     getLEIAInstitutionPreSaleContract,
//     getOlympusPreSaleContract,
//     getOlympusInstitutionPreSaleContract,
//     getPreSaleContract,
//     getinstitutionpresalecontract,
//     getLuckifyContract,
//     getScrexContract,
//     getGEMSPreSaleContract
// } from "./contractHelpers"; // adjust this path as per your actual import location
// import Environment from "./Environment";


// export function getContracts(project, web3) {
    
//     let contract = null;
//     let contractInstitution = null;

//     switch (project) {
//         case "RAIN":
//             contract = getRainPreSaleV3Contract(Environment.RainPreSaleV3, web3);
//             contractInstitution = getRainInstitutionPreSaleContract(Environment.RainInstitutionPreSale, web3);
//             break;

//         case "MATCHAIN":
//             contract = getMatchainContract(Environment.MATCHAINPreSale, web3);
//             break;
//         case "LUCKIFY": 
//             contract = getLuckifyContract(Environment.LUCKIFYPreSale, web3);
//             break;
//         case "SCREX":
//             contract = getScrexContract(Environment.SCREXPreSale, web3);
//             break;
//         case "ASTRANOVA":
//             contract = getAstroNovaPreSaleV2Contract(Environment.AstroNovaPreSaleV2, web3);
//             break;

//         case "NFA":
//             contract = getNFAPreSaleContract(Environment.NFAPreSale, web3);
//             break;

//         case "LEIA":
//             contract = getLEIAPreSaleContract(Environment.LEIAPreSale, web3);
//             contractInstitution = getLEIAInstitutionPreSaleContract(Environment.LEIAInstitutionPreSale, web3);
//             break;

//         case "OLYMPUS":
//             contract = getOlympusPreSaleContract(Environment.OlympusPreSale, web3);
//             contractInstitution = getOlympusInstitutionPreSaleContract(Environment.OlympusInstitutionPreSale, web3);
//             break;

//         case "INCENTIV":
//             contract = getPreSaleContract(Environment.PreSale, web3);
//             contractInstitution = getinstitutionpresalecontract(Environment.InstitutionPreSale, web3);
//             break;
//         case "GEMS":
//             contract = getGEMSPreSaleContract(Environment.GemsPreSale, web3);
//             break;

//         default:
//             console.warn("Unknown project:", project);
//     }

//     return { contract, contractInstitution };
// }
